var render = function render() {
  var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy;return _c('div', { staticClass: "multi-ratio-upload" }, [_c('common-uploader', _vm._b({}, 'common-uploader', _vm.uploaderAttrs, false), [_vm.cover.url[_vm.item] ? _c('div', { staticClass: "icon-avatar" }, [_c('img', { attrs: { "src": _vm.cover.url[_vm.item] } })]) : _c('pt-icon', { attrs: { "color": "#666", "size": 24 } }, [_vm.loading ? _c('ic-loading') : _c('ic-add')], 1)], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.item))])], 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };